<template>
  <div class="filter-gender">
    <p class="text-body lg:text-white mb-4">
      {{ $t('common.labels.tutor_gender') }}
    </p>
    <div
      v-if="run"
      class="filter-gender__wrapper"
    >
      <BaseRadioButtonGroup
        :options="options"
        :value="gender"
        :name="platform + '_gender'"
        @update="optionUpdated"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'FilterInputGenderMobile',
  props: {
    emitResponse: {
      type: Boolean,
      default: false
    },
    platform: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      run: true,
      gender: null
    }
  },
  computed: {
    ...mapGetters('local', ['getListQueries', 'getListQueries']),
    options () {
      return [
        {
          name: 'Both',
          value: null
        },
        {
          name: 'Male',
          value: 'male'
        },
        {
          name: 'Female',
          value: 'female'
        }
      ]
    }
  },
  watch: {
    '$route' (val) {
      if (val && val.query) {
        this.gender = val.query.teacher_gender || null
      }
    }
  },
  created () {
    if (this.getListQueries && this.getListQueries.teacher_gender) {
      this.gender = this.getListQueries.teacher_gender
    }
  },
  methods: {
    ...mapActions('local', ['updateListQueries']),
    async optionUpdated (val) {
      await this.updateListQueries({ teacher_gender: val, ignore_skip: null, page_number: null })
      // if (this.$route.query?.page_number) {
      //   await this.updateListQueries({ page_number: null, ignore_skip: false })
      // }
      if (this.emitResponse) {
        this.gender = val
        this.$emit('updated')
      } else {
        const queryParams = { ...this.$route.query }
        if (queryParams.page_number) {
          delete queryParams.page_number
        }
        if (val) {
          queryParams.teacher_gender = val
        } else {
          delete queryParams.teacher_gender
        }
        this.$router.push(this.localePath({
          path: this.$route.path,
          query: queryParams
        }))
        // this.$nuxt.$emit('fetchList')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.filter-gender {
  &__wrapper {
    @apply bg-white lg:border rounded-2xl lg:border-border-text-field lg:h-14 h-12 lg:px-3
    lg:text__text-input-md--regular text__text-input-md--regular text-title lg:flex items-center;
  }
}
</style>
